import { render, staticRenderFns } from "./EnContactPage.vue?vue&type=template&id=11b3dddc"
import script from "./EnContactPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnContactPage.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports